import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Benefits from "./components/Benefits";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonTable from "./components/ComparisonTable";
import HowItWorks from "./components/HowItWorks";
import SafeShopping from "./components/SafeShopping";
import FAQ from "./components/FAQ";
import CTASection from "./components/CTASection";
import LatestArticles from "./components/LatestArticles";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://cssbuy.biz";

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "CSSBuy Spreadsheet Brasil",
  "url": SITE_URL,
  "description": "Melhor CSSBuy Spreadsheet 2026 com links, guias e planilhas atualizadas para compras internacionais.",
  "inLanguage": "pt-BR",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_URL}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "CSSBuy Brasil",
  "url": SITE_URL,
  "description": "Autoridade em CSSBuy Spreadsheet, links, Yupoo e guias de compra para o mercado brasileiro.",
  "foundingDate": "2025",
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer support",
    "availableLanguage": ["Portuguese"],
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <main>
        <article>
          <Hero />
          <Benefits />
          <CategoryGrid />
          <ComparisonTable />
          <HowItWorks />
          <SafeShopping />
          <FAQ />
          <CTASection />
          <LatestArticles />
        </article>
      </main>
      <Footer />
    </>
  );
}